const dayAndMonth = new Intl.DateTimeFormat("fr-FR", {
  day: "numeric",
  month: "short",
});

export const formatShortDate = (value: unknown) =>
  value ? dayAndMonth.format(new Date(value as string)) : "—";
